import { render, staticRenderFns } from "./Zingfit.vue?vue&type=template&id=4356c0d1&scoped=true&"
import script from "./Zingfit.vue?vue&type=script&lang=js&"
export * from "./Zingfit.vue?vue&type=script&lang=js&"
import style0 from "./Zingfit.vue?vue&type=style&index=0&id=4356c0d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4356c0d1",
  null
  
)

export default component.exports